import Vue from "vue";
import ConfirmationModal from "../components/ConfirmationModal.vue";

export const Modal = {
  showConfirmationModal({ message, title }) {
    return new Promise((resolve, reject) => {
      const ComponentClass = Vue.extend(ConfirmationModal);
      const instance = new ComponentClass({
        propsData: {
          message: message,
          title: title,
          onConfirm: () => {
            instance.$destroy(true);
            instance.$el.remove();
            resolve(true);
          },
          onDecline: () => {
            instance.$destroy(true);
            instance.$el.remove();
            resolve(false);
          },
        },
      });
      instance.$mount();
      document.getElementById("modalLocation").appendChild(instance.$el);
    });
  },
};
